export const PLATFORM_MARKUP = 0.20;
export const DEPOSIT_RATE = 1.00;

// Preview only. The backend remains authoritative for every amount sent to Stripe.
// Keep defaults aligned with the backend's Australian domestic-card assumptions.
export const STRIPE_CARD_FEE_RATE = Number(process.env.REACT_APP_STRIPE_CARD_FEE_RATE || 0.017);
export const STRIPE_CARD_FIXED_FEE_CENTS = Number(process.env.REACT_APP_STRIPE_CARD_FIXED_FEE_CENTS || 30);

const round2 = (n) => Math.round(Number(n || 0) * 100) / 100;
const toCents = (dollars) => Math.round(round2(dollars) * 100);

// Service rate displayed to the client (provider quote + 20% platform markup).
export const clientPrice = (providerRate) => round2(providerRate * (1 + PLATFORM_MARKUP));

const grossUpCardFee = (netCents) => {
  const net = Math.max(0, Math.round(Number(netCents) || 0));
  if (!net) return 0;
  const rate = Number.isFinite(STRIPE_CARD_FEE_RATE) ? STRIPE_CARD_FEE_RATE : 0.017;
  const fixed = Number.isFinite(STRIPE_CARD_FIXED_FEE_CENTS)
    ? Math.max(0, Math.round(STRIPE_CARD_FIXED_FEE_CENTS))
    : 30;
  return Math.ceil((net + fixed) / (1 - rate));
};

// Client preview: 100% of the initial booking is charged after acceptance.
 // A later balance exists only when approved additional tasks add more service time.
// Processing recovery is merged into the displayed amounts; no separate fee line.
export const bookingClientPricing = (providerRate, hours) => {
  const safeHours = Math.max(0, Number(hours) || 0);
  const serviceTotalCents = toCents(clientPrice(providerRate) * safeHours);
  const depositServiceCents = Math.round(serviceTotalCents * DEPOSIT_RATE);
  const balanceServiceCents = Math.max(0, serviceTotalCents - depositServiceCents);

  const depositCents = grossUpCardFee(depositServiceCents);
  const balanceCents = grossUpCardFee(balanceServiceCents);

  return {
    serviceTotal: serviceTotalCents / 100,
    clientTotal: (depositCents + balanceCents) / 100,
    depositAmount: depositCents / 100,
    balanceAmount: balanceCents / 100,
  };
};

// Retained for compatibility with callers that need the upfront-payment preview.
export const depositOf = (providerRate, hours = 1) =>
  bookingClientPricing(providerRate, hours).depositAmount;